import React, { useEffect, useState } from "react";
import _ from "lodash";
import Loading from "../../components/callback/loading";
import { getLocaleOptions, getLookups, getGs1Codes, getNewLookups, getRegularImageViews } from "../../components/photography/lib/photoData";
import { PhotographyProvider } from "./index";

const PhotographyLookups = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [lookups, setLookups] = useState({
        imageViews: [],
        packageTypes: [],
        imageViewOptions: [],
        localeOptions: [],
        localeByKey: {},
        groups: [],
        groupShots: [],
        imageTypeOptions: [],
        imageFacingOptions: [],
        imageAngleOptions: [],
        imageStateOptions: [],
        newPackageTypes: [],
    });

    useEffect(() => {
        async function fetchData() {
            const localeOptions = await getLocaleOptions();
            const response = await getLookups(props.includeMultipleImageEligibleItems);
            const newPackageTypes = await getNewLookups();
            const newImageViews = await getRegularImageViews();
            const gs1Codes = await getGs1Codes();

            if (!response) {
                return;
            }

            const shotsToRemove = _.filter(response.imageViews, { isPremiumEditing: false, isActive: true, isVisibleInPicklist: true });
            const filteredOldViews = _.reject(response.imageViews, (image) => _.find(shotsToRemove, { imageViewCode: image.imageViewCode }));
            const updatedImageList = [...newImageViews, ...filteredOldViews];

            const activeShots = updatedImageList.filter((v) => v.isActive);
            const groupShots = updatedImageList.filter((v) => v.isGroupShot);
            const imageViewOptions = activeShots.map((as) => {
                return { value: as.imageViewCode, text: as.isPremiumEditing ? `★ ${as.name}` : as.name };
            });
            const localeByKey = localeOptions.reduce((obj, l) => {
                obj[l.value] = l;

                return obj;
            }, {});

            setLookups({
                imageViews: activeShots,
                imageViewOptions,
                localeOptions,
                localeByKey,
                packageTypes: response.packageTypes,
                newPackageTypes,
                groups: response.groups,
                groupShots: groupShots,
                imageTypeOptions: gs1Codes.imageTypeOptions,
                imageFacingOptions: gs1Codes.imageFacingOptions,
                imageAngleOptions: gs1Codes.imageAngleOptions,
                imageStateOptions: gs1Codes.imageStateOptions,
            });
            setIsLoaded(true);
        }

        fetchData();
    }, []);

    const convertToDropdownList = (list) => {
        return list.map((iv) => {
            return {
                value: iv.shortName,
                // Add a flag if the image type is premium
                text: (iv.isPremiumEditing ? "[Prem] " : "") + iv.name,
            };
        });
    };

    if (!isLoaded) {
        return <Loading />;
    }

    return <PhotographyProvider value={{ lookups, convertToDropdownList }}>{props.children}</PhotographyProvider>;
};

export default PhotographyLookups;
